import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import Navigation from '../components/Layout/Navigation';
import AppFooter from '../components/Layout/AppFooter';
import ErrorBoundary from '../components/Common/ErrorBoundary';
import TrialBanner from '../components/Common/TrialBanner';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  return (
    <ProtectedRoute>
      <>
        <Navigation />
        <TrialBanner />
        <ErrorBoundary>{children}</ErrorBoundary>
        {/*
          Sits after the content rather than pinned to the viewport bottom:
          `PageLayout` already sets `min-h-screen`, so a flex-column shell here
          would fight it — and turning Navigation into a flex item risks its
          `position: sticky` on every page. One small scroll to reach the footer
          is the cheaper trade.
        */}
        <AppFooter />
      </>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;
